<template>
  <div class="directories-business">
    <b-card no-body class="custom-card">
      <b-card-header class="py-2 px-3 custom-card-header">
        <b-row align-v="center">
          <b-col cols="6">
            <h3 class="mb-0">Directorships And Business Interests</h3>
          </b-col>
          <b-col cols="6" class="text-right" v-if="directoriesBusiness.length > 0">
            <b-link href="javascript:void(0)" @click="modals.show_directories_full_view = true" class="full-view-link">
              <b-icon icon="eye-fill" variant="primary"></b-icon>
              Full View
            </b-link>
          </b-col>
        </b-row>  
      </b-card-header>

      <!-- Table when data exists -->
      <div v-if="directoriesBusiness.length > 0">
        <!-- Note Section -->
        <b-card-body class="pb-2 pt-3 note-section">
          <p class="text-xs text-muted mb-0">
            <strong>Note:</strong> The percentage of shareholding is not considered due to the number of shares information in this report comprises of Preference Shares/ Other Shares. Please purchase Form 24 from Idaman to accurately determine percentage of shareholdings for each shareholder.
          </p>
        </b-card-body>

        <!-- Table -->
        <div class="table-container">
          <table class="directories-table bordered summary-table">
            <thead>
              <tr>
                <th style="width: 60px">No.</th>
                <th>Company</th>
                <th>Position</th>
                <th>Appoint</th>
                <th>Resign Date</th>
                <th>Profit After Tax (RM)</th>
                <th>Year</th>
                <th>Status</th>
                <th>Shareholding (%)</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(business, index) in directoriesBusiness" :key="index">
                <td style="text-align: center">{{ index + 1 }}.</td>
                <td>
                  <div class="company-name">{{ business.company_name }}</div>
                </td>
                <td>{{ business.position || '-' }}</td>
                <td style="text-align: center">{{ formatDate(business.appointment_date) }}</td>
                <td style="text-align: center">{{ formatDate(business.resignation_date) }}</td>
                <td style="text-align: center">{{ business.profit_after_tax ? formatCurrency(business.profit_after_tax) : '-' }}</td>
                <td style="text-align: center">{{ business.latest_financial_year || '-' }}</td>
                <td style="text-align: center">{{ business.status || '-' }}</td>
                <td style="text-align: center">{{ business.share_percentage || '-' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- No data message -->
      <div v-else class="no-data-section">
        <p class="text-xs mb-0">No Directorships And Business Interests recorded</p>
      </div>
    </b-card>

    <!-- Full View Modal -->
    <DirectoriesBusinessModal
      :directoriesBusiness="directoriesBusiness" 
      :addressRecords="addressRecords" 
      :show_directories_full_view.sync="modals.show_directories_full_view"
    />
  </div>
</template>

<script>
import DirectoriesBusinessModal from '@/views/CustomerProfile/CustomerModals/DirectoriesBusinessModal.vue'

export default {
  name: 'directoriesBusiness',
  props: {
    directoriesBusiness: {
      type: Array,
      default: () => [] // ensures it's never undefined
    },
    addressRecords: {
      type: Array,
      default: () => [] // ensures it's never undefined
    },
  },
  components: {
    DirectoriesBusinessModal,
  },
  data() {
    return {
      modals: {
        show_directories_full_view: false
      }
    }
  },
  methods: {
    formatNumber(value) {
      if (!value) return '-';
      // Format number with commas
      return Number(value).toLocaleString('en-US');
    },
    
    formatDate(dateString) {
      if (!dateString) return '-';
      
      try {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        }).replace(/\//g, '-');
      } catch (e) {
        return dateString;
      }
    },
    
    formatCurrency(value) {
      if (!value) return '-';
      
      // Format number with commas for thousands
      return parseFloat(value).toLocaleString('en-MY', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }
  },
  mounted() {
   console.log('Directories Business Data:', this.directoriesBusiness);
  }
};
</script>

<style scoped>
.directories-business {
  font-family: inherit;
}

.custom-card {
  border: 1px solid #dee2e6;
  border-radius: 4px;
}

.custom-card-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

.full-view-link {
  color: #007bff;
  text-decoration: none;
  font-weight: 500;
}

.full-view-link:hover {
  text-decoration: underline;
}

.note-section {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

.no-data-section {
  background-color: #f8f9fa;
  padding: 12px;
  text-align: center;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

.company-name {
  word-break: break-word;
  line-height: 1.2;
}

.text-xs {
  font-size: 0.75rem;
}

.table-container {
  width: 100%;
  overflow-x: auto;
}

/* Styles matching legal cases tables */
.directories-table {
  border-collapse: collapse;
  width: 100%;
  font-family: inherit;
  font-size: 0.875rem;
  margin-bottom: 0;
}

.directories-table.bordered,
.directories-table th,
.directories-table td {
  border: 1px solid #000 !important;
}

/* Summary table specific header styling */
.summary-table th {
  background-color: #252938 !important;
  color: #fff !important;
  border: none !important;
  vertical-align: top !important;
  text-transform: none !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 19.5px !important;
  padding: 9px 12px !important;
  text-align: center;
}

.directories-table td {
  background-color: #fff !important;
  color: #000 !important;
  padding: 8px 6px;
  text-align: left;
  vertical-align: middle;
}

.directories-table tbody tr:nth-child(even) {
  background-color: #f8f9fa;
}

.directories-table tbody tr:nth-child(odd) {
  background-color: #ffffff;
}

/* Remove any Element-UI table styles and use custom table instead */
::v-deep .el-table {
  display: none;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .table-container {
    font-size: 0.7rem;
  }
  
  .directories-table th,
  .directories-table td {
    padding: 6px 4px;
  }
}
</style>